module.exports = __webpack_public_path__ + "static/media/0030_LES_STRUCTURES_ILV.edbab472.webp";